import { useCallback, useMemo } from 'react'
import { useLocalStorageState } from '@toolpad/core'

export const V3_ZOOM_FONT_DEFAULT = 14
const FONT_MIN = 12
const FONT_MAX = 20
const ROW_DEFAULT = 32

const clamp = (value: number, min: number, max: number) => Math.min(max, Math.max(min, value))

export const useInventoryV3Zoom = (storageKey: string) => {
  const [fontSize, setFontSize] = useLocalStorageState<number>(storageKey, V3_ZOOM_FONT_DEFAULT, {
    codec: { parse: Number, stringify: String },
  })
  const resolvedFontSize = clamp(
    Number.isFinite(fontSize) ? Number(fontSize) : V3_ZOOM_FONT_DEFAULT,
    FONT_MIN,
    FONT_MAX,
  )

  const rowHeight = useMemo(
    () => Math.round(ROW_DEFAULT * (resolvedFontSize / V3_ZOOM_FONT_DEFAULT)),
    [resolvedFontSize],
  )

  const zoomBy = useCallback(
    (factor: number) => {
      setFontSize(current => clamp(Math.round((current ?? V3_ZOOM_FONT_DEFAULT) * factor), FONT_MIN, FONT_MAX))
    },
    [setFontSize],
  )

  const zoomIn = useCallback(() => zoomBy(1.1), [zoomBy])
  const zoomOut = useCallback(() => zoomBy(1 / 1.1), [zoomBy])

  return {
    fontSize: resolvedFontSize,
    rowHeight,
    zoomIn,
    zoomOut,
    canZoomIn: resolvedFontSize < FONT_MAX,
    canZoomOut: resolvedFontSize > FONT_MIN,
  }
}
